import React, { useState } from 'react';
import './BulkRenderModal.css';

function BulkRenderModal({ isOpen, onClose, onConfirm, projectId, languages }) {
  const [syncMedia, setSyncMedia] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    setIsLoading(true);
    onConfirm(syncMedia);
  };

  const languagesList = languages.map(lang =>
    lang === 'original' ? 'Original' : lang.charAt(0).toUpperCase() + lang.slice(1)
  ).join(', ');

  return (
    <div className="modal-overlay">
      <div className="modal bulk-render-modal">
        <div className="modal-header">
          <h2>🎬 Bulk Render Confirmation</h2>
          <button
            className="modal-close-button"
            onClick={onClose}
            disabled={isLoading}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div className="confirmation-section">
            <div className="info-section">
              <h3>Render Details</h3>
              <div className="render-info">
                <div className="info-item">
                  <span className="info-label">Languages:</span>
                  <span className="info-value">{languages.length}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">List:</span>
                  <span className="info-value">{languagesList}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Project ID:</span>
                  <span className="info-value">{projectId}</span>
                </div>
              </div>
            </div>

            <div className="sync-section">
              <div className="sync-header">
                <h3>Media Synchronization</h3>
                <p className="sync-description">
                  Sync media files from live server to ensure all assets are available locally
                </p>
              </div>

              <div className="sync-toggle">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={syncMedia}
                    onChange={(e) => setSyncMedia(e.target.checked)}
                    disabled={isLoading}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="toggle-label">
                  {syncMedia ? '✅ Sync media before rendering' : '❌ Skip media sync'}
                </span>
              </div>

              {syncMedia && (
                <div className="sync-warning">
                  <div className="warning-icon">⚠️</div>
                  <div className="warning-text">
                    <strong>Media sync will download all project files from the live server.</strong>
                    <br />
                    This may take several minutes depending on file sizes.
                  </div>
                </div>
              )}
            </div>

            <div className="process-info">
              <h3>Process Overview</h3>
              <ol className="process-steps">
                {syncMedia && <li>🔄 Sync media files from live server</li>}
                <li>🎬 Render videos for all languages sequentially</li>
                <li>🔔 Play notification sound when complete</li>
                <li>📊 Show completion summary</li>
              </ol>
            </div>

            <div className="warning-section">
              <div className="warning-icon">⏱️</div>
              <div className="warning-text">
                <strong>Estimated Time:</strong>
                <br />
                {syncMedia ? '5-15 minutes' : '3-10 minutes'} depending on content complexity
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="modal-cancel-button"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="modal-confirm-button"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span>
                Starting...
              </>
            ) : (
              <>
                🚀 Start Bulk Render
                {syncMedia ? ' & Sync' : ''}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkRenderModal;